import { put, call, takeLatest } from "redux-saga/effects";
import { alertConstants, authConstants, fileAccessLogConstants } from "_constants";
import { fileAccessLogService } from "_services";

export function* getFileAccessLogSagaAdmin(action) {
  try {
    const logs = yield call(fileAccessLogService.getFileAccessLog, action.payload);
    console.log("[getFileAccessLogSaga] received logs:", logs?.length);

    yield put({
      type: fileAccessLogConstants.GET_FILE_ACCESS_LOG_SUCCESS,
      payload: logs,
    });
  } catch (error) {
    if (error.message === "Invalid Auth Token") {
      yield put({ type: authConstants.LOGOUT });
    }
    yield put({
      type: fileAccessLogConstants.GET_FILE_ACCESS_LOG_FAILURE,
      payload: error.message,
    });
    yield put({
      type: alertConstants.ERROR,
      payload: { message: error.message },
    });
  }
}

export function* watchFileAccessLogAdmin() {
  yield takeLatest(fileAccessLogConstants.GET_FILE_ACCESS_LOG_REQUEST, getFileAccessLogSagaAdmin);
}
